import { NewCarCard } from "GlobalComponent/Card/NewCarCard";
import React, { memo } from "react";
import CarouselContainer from "GlobalComponent/Carousel/CarouselContainer";
import { platform as PLATFORM } from "GlobalEnum/Platform";
import { getPicPageUrl } from "GlobalUtils/UrlFactory";

const getPicLinkData = (car, cityName, cityMaskingName) => {
  if (!cityMaskingName) {
    return null;
  }
  const url = getPicPageUrl(
    car.makeMaskingName,
    car.modelMaskingName,
    cityMaskingName
  );
  const track = {
    action: "viewpricebreakup_click",
    actionImp: "viewpricebreakup_shown",
    label: `${car.modelName}_${cityName}`,
  };
  return {
    url,
    isGaTrack: true,
    isGaImpTrack: true,
    text: "View Price Breakup",
    track,
  };
};

export const NewCarCarousel = memo(function NewCarCarousel({
  data,
  openLocationPopup,
  pageName,
  cardClickAction,
  cardImpAction,
  dataTestingId,
  containerClasses,
  getTrackingProps,
  slidesPerView = 2,
  platform = PLATFORM.MOBILE,
  showPicLink = false,
  cityName,
  cityMaskingName,
}) {
  if (!data || data.length < 1) {
    return null;
  }
  const isSingleCard = data.length === 1;
  return (
    <CarouselContainer
      className={containerClasses}
      platForm={platform}
      data-testing-id={dataTestingId}
      slidesPerView={slidesPerView}
    >
      {data.map((car, index) => {
        let trackingProps;
        if (getTrackingProps) {
          trackingProps = getTrackingProps(index + 1, car.modelName);
        }
        return (
          <NewCarCard
            data={car}
            openLocationPopup={openLocationPopup}
            isSingleCard={isSingleCard}
            pageName={pageName}
            cardClickAction={cardClickAction}
            cardImpAction={cardImpAction}
            customTrackingProps={trackingProps}
            key={`new-car-${car.modelId}`}
            uniqueKey={`new-car-${car.modelId}`}
            platForm={platform}
            picLink={
              showPicLink
                ? getPicLinkData(car, cityName, cityMaskingName)
                : null
            }
            dataTestingId={dataTestingId}
          />
        );
      })}
    </CarouselContainer>
  );
});
NewCarCarousel.displayName = "NewCarCarousel";
